import React from "react";
import ReactDOM from "react-dom";

import "assets/scss/material-dashboard-pro-react.scss?v=1.8.0";
import AppProviders from "AppProviders";
import App from "App";

import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {
    primary: {
      light: "#a6d4fa",
      main: "#f73d51",
      dark: "#648dae",
    },
  },
});

ReactDOM.render(
  <MuiThemeProvider theme={theme}>
    <AppProviders>
      <App />
    </AppProviders>
  </MuiThemeProvider>,
  document.getElementById("root")
);